import { defineComponent as _defineComponent } from 'vue'
import CInput from '@/components/shared/CInput';
import CButtonGroup, { type CButtonGroupItem } from '@/components/shared/CButtonGroup';
import CalendarColorField from './CalendarColorField.vue';
import CalendarFieldTitle from './CalendarFieldTitle.vue';
import CalendarStrokeField from './CalendarStrokeField.vue';
import { useCalendarConfig } from './useCalendarConfig';
import type { ImagePlaceholderElement } from '@/typings/customilyElements/canvasElements';
import type { CalendarConfig, CalendarStrokeValue } from './types';


export default /*#__PURE__*/_defineComponent({
  __name: 'GeneralProperties',
  props: {
    imageElement: null
  },
  emits: ["update-config"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update-config', config: Partial<CalendarConfig>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    imageElement?: ImagePlaceholderElement;
};

const BACKGROUND_MODES: CButtonGroupItem<boolean>[] = [
    { label: 'Unified Background', value: true },
    { label: 'Separate Background Colors', value: false }
];

const SEPARATE_BACKGROUNDS: {
    title: string;
    key: 'multiBGYearMonthColor' | 'multiBGDaysTitlesColor' | 'multiBGDaysColor';
}[] = [
    { title: 'Month & Year Background', key: 'multiBGYearMonthColor' },
    { title: 'Day Titles Background', key: 'multiBGDaysTitlesColor' },
    { title: 'Days Background', key: 'multiBGDaysColor' }
];

// Vue 2.7 SFC compiler cannot resolve imported types in defineProps



const { config, elementKey, disabled, update } = useCalendarConfig(props, emit);

const onStrokeUpdate = ({ width, color }: CalendarStrokeValue) => {
    update({ BGBorderWidth: width, BGBorderColor: color });
};

return { __sfc: true,BACKGROUND_MODES, SEPARATE_BACKGROUNDS, props, emit, config, elementKey, disabled, update, onStrokeUpdate, CInput, CButtonGroup, CalendarColorField, CalendarFieldTitle, CalendarStrokeField }
}

})